import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const appRoutes: Routes = [
  {path: '', redirectTo: 'admin/patients', pathMatch: 'full'},
  {path: 'links', loadChildren: '../mobile-app-links/mobile-app-links.module#MobileAppLinksModule'},
  {path: '**', redirectTo: '/links/app-links'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [RouterModule]
})
export class RoutingModule {
}



// WEBPACK FOOTER //
// A:/CM/links-ui/cm-ui-app-links/src/app/routing/routing.module.ts